if(document.querySelector('.stats-wrapper')) {
    let body = document.querySelector('.stats-wrapper')
    let confItems = document.querySelectorAll('.open-conf')
    let header = document.querySelector('.dashboard-header')
    let title = document.querySelector('.conf-title')
    let archive = document.querySelector('.select-conf-wrapper')
    let single = document.querySelector('.conf-stats')
    let fromField = document.querySelector('#from')
    let toField = document.querySelector('#to')
    let close = document.querySelector('.close-conf')
    let selected = 0
    let from = fromField.mask.unmaskedValue
    let to = toField.mask.unmaskedValue
    let update_btn = document.querySelector('#update_stats')

    if(confItems.length) {
        for(let item of confItems) {
            item.addEventListener('click', () => {
                let {id, name} = item.dataset

                title.textContent = name

                header.hide()
                archive.classList.remove('show')
                single.classList.add('show')

                selected = id

                updateStats()
            })
        }
    }

    if(close) {
        close.addEventListener('click', () => {
            header.show()
            archive.classList.add('show')
            single.classList.remove('show')
        })
    }

    if(update_btn) {
        update_btn.addEventListener('click', () => {
            let checkFields = [fromField, toField]
            let errors = 0

            for(let field of checkFields) {
                errors += field.check()
            }

            if(!errors) {
                from = fromField.mask.unmaskedValue
                to = toField.mask.unmaskedValue

                updateStats()
            }
        })
    }

    function updateStats() {
        body.startLoading()

        requestAxios('updateStats', {from, to, id: selected}, async (res) => {
            let totalHoursElement = document.querySelector('.total-hours')
            let avarageHoursElement = document.querySelector('.avarage-hours')
            let usersCountElement = document.querySelector('.users-count')
            let appendUsersElement = document.querySelector('.append-users')
            let {avarage_hours, hours, users} = res
            let usersList = []

            totalHoursElement.textContent = hours + ' ч.'
            avarageHoursElement.textContent = avarage_hours + ' ч.'
            usersCountElement.textContent = users ? Object.keys(users).length : 0

            appendUsersElement.innerHTML = ''

            if(Object.keys(users).length) {
                for(let name in users) {
                    let userData = users[name]
                    let {dates, total} = userData
                    let element = await document.createElement('div')
                    let percents = Math.round((total / hours) * 100)
                    let dropdown = []
    
                    element.innerHTML = `
                    <div class="item-info">
                        <div class="user">
                            <div class="avatar">${name.charAt(0)}</div>
                            <div class="name">${name}</div>
                        </div>
                        <div class="progress-wrapper">
                            <div class="hours">${total} ч.</div>
                            <div class="progress">
                                <div class="line" style="width: ${percents}%"></div>
                            </div>
                        </div>
                        <div class="show-more icon-down"></div>
                    </div>
                    <div class="item-dropdown"></div>
                    `
    
                    element.classList.add('list-item')
                    element.sort = total

                    for(let time in dates) {
                        let item = await document.createElement('div')
                        let rawHours = dates[time]
                        let hours = []
                        let hoursStructure = []

                        for(let item of rawHours) {
                            item = new Date(item)
                            hours.push(item.time())
                        }

                        let date = new Date(time).dmY()

                        for(let i = 7; i <= 22; i++) {
                            i = i < 10 ? '0' + i : i

                            let item = []

                            for(let t = 0; t <= 1; t++) {
                                let mins = t * 30
                                let time = mins ? i + ':' + mins : i + ':00'

                                if(hours.includes(time)) {
                                    item.push(`<div class="item active">${time}</div>`)
                                } else {
                                    item.push(`<div class="item">${time}</div>`)
                                }
                            }

                            hoursStructure.push(`<div class="hour-wrapper">${item.join('')}</div>`)
                            
                        }

                        hoursStructure = hoursStructure.join('')
                        item.classList.add('row')
                        item.sort = new Date(time).getTime()
                        item.innerHTML = `
                            <div class="date">${date}</div>
                            <div class="hours">${hoursStructure}</div>
                        `

                        dropdown.push(item)
                    }

                    dropdown.sort((a, b) => {
                        return b.sort - a.sort
                    })

                    for(let item of dropdown) {
                        element.querySelector('.item-dropdown').appendChild(item)
                    }

                    let showMore = element.querySelector('.show-more')

                    showMore.addEventListener('click', () => {
                        element.classList.toggle('active')
                    })
    
                    usersList.push(element)
                }
    
                usersList.sort((a, b) => {
                    return b.sort - a.sort
                })

                for(let element of usersList) {
                    appendUsersElement.appendChild(element)
                }
            } else {
                appendUsersElement.innerHTML = `
                    <div class="empty-block">Нет данных</div>
                `
            }

            body.stopLoading()
        })
    }
}